import { FunctionComponent, SVGProps } from "react";

import { ArrowsLeftRight, Pulse } from "components/icons/generated";
import { IconEmphasizedColor } from "ds/components/IconEmphasized/types";

// TODO: [dashboard] those colors will be changed because of accessibility issues
export const vendors: Record<
  string,
  {
    logo: FunctionComponent<SVGProps<SVGSVGElement>>;
    iconColor: IconEmphasizedColor;
    color: string;
    inactiveColor: string;
    activeColor: string;
  }
> = {
  drifted: {
    logo: ArrowsLeftRight,
    iconColor: "status-negative",
    color: "var(--semantic-color-background-interactive-data-semantic-negative-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-semantic-negative-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-semantic-negative-inactive)",
  },
  healthy: {
    logo: Pulse,
    iconColor: "status-positive",
    color: "var(--semantic-color-background-interactive-data-semantic-positive-rest)",
    activeColor: "var(--semantic-color-background-interactive-data-semantic-positive-hovered)",
    inactiveColor: "var(--semantic-color-background-interactive-data-semantic-positive-inactive)",
  },
};
